import { AnalyticsStore } from 'bernie-plugin-mobx';

import { updateSearch } from 'bernie-core';

import { SearchResultsStore } from 'src/common/stores/search-results-store';

import { History, Location } from 'history';

export const handleMapTrigger = (
  history: History,
  location: Location,
  searchResults: SearchResultsStore,
  analytics?: AnalyticsStore
) => () => {
  searchResults.shouldFetch = true;
  updateSearch({ history, location, newParams: { pwaOverlay: 'map' } });
  if (analytics && typeof analytics.trackEvent === 'function') {
    analytics.trackEvent('Module.MapOpen.Link', 'Launch dynamic map', null);
  }
};

// Trigger a client fetch to get Property results which are needed for the map
export const forceFetchProperties = (searchResults: SearchResultsStore) => () => {
  searchResults.shouldFetch = true;
};
